import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { storeActions } from '../../../store'
import renderAttachment from '../../Middlewares/attachmentMiddleware'
import Card from '../../AnswerPanel/Card'
import { DirectLineAttachment } from '../../../models/directLine'

interface SingleCardContainerProps {
  attachment: DirectLineAttachment
  history?: boolean
  activityId: string
  triggerScroll?: () => void
}

const SingleCardContainer = ({ attachment, history, activityId, triggerScroll }: SingleCardContainerProps): JSX.Element => {
  const dispatch = useDispatch()

  useEffect(() => {
    triggerScroll?.()
  }, [])

  return attachment.contentType.includes('.card') ? (
    <Card
      className={
        history
          ? 'rf-w-full'
          : 'rf-w-full rf-min-w-full landscape-retorik:rf-w-[48%] landscape-retorik:rf-min-w-[48%] landscape-retorik:rf-ml-1/5 large-vertical:rf-w-3/5 large-vertical:rf-min-w-3/5 rf-max-h-full'
      }
    >
      {renderAttachment({
        attachment: attachment,
        history: history
      })}
    </Card>
  ) : (
    <React.Fragment>
      {renderAttachment({
        attachment: attachment,
        history: history,
        activityId: activityId,
        setModalFullscreenContent: (value: JSX.Element | null, activityId: string) => dispatch(storeActions.utils.setModalFullscreenContentFromActivity({ value: value, fromActivity: activityId }))
      })}
    </React.Fragment>
  )
}

export default SingleCardContainer
